module.exports = __webpack_public_path__ + "./images/09767c0bfe2d00aee5a4b6b595bc7894.jpg";